<div *ngIf="!accepted" class="notification is-primary is-light caddie-cookie-disclaimer">
    <!-- <button class="delete"></button> -->
    <h5 class="title is-5">Data Privacy</h5>
    This website stores only data that is required in order to provide you with a fully functional service. No personal data is collected.
    <br>
    <br>
    <button class="button is-primary" (click)="accept()">Got it</button>
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    <button class="button is-primary" (click)="informationLink()">I want to know more</button>
</div>      